

















































































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import QuotaDetailsContainer from '../quota-detail-container/index.vue';
import QuotaStepInfo from '../quota-step-info/index.vue';
import StepLegend from '../step-legend/index.vue';
import { PropType } from 'vue';
import { Ios14Quota } from '@tt4b/ttam-enums';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-ios14-info-quota-detail-adgroup';
export default defineComponent({
  name,
  props: {
    ios14Quota: {
      type: Object as PropType<Ios14Quota>,
    },
    eventManagerUrl: {
      type: String,
    },
  },
  components: { StepLegend, QuotaStepInfo, QuotaDetailsContainer, ALink },
  setup(props) {
    const { ios14Quota } = toRefs(props);
    const quotaUsed = computed(() => ios14Quota.value?.adgroupQuota?.usingQuota ?? 0);
    const quotaTotal = computed(() => ios14Quota.value?.adgroupQuota?.totalQuota ?? 0);
    const quotaRemain = computed(() => ios14Quota.value?.adgroupQuota?.availableQuota ?? 0);

    const legends = computed(() => {
      let arr: string[] = [];
      if (quotaUsed.value > 0) {
        arr.push('used');
      }
      arr.push('unused');

      return arr;
    });

    return {
      name,
      quotaUsed,
      quotaTotal,
      quotaRemain,
      legends,
    };
  },
});
